import VuexErrors from 'src/vuex/modules/errors'
export default {
  namespaced: true,

  state () {
    return {
      showHamIcon: false,
      navBarState : null 
    }
  },

  getters: {
    showHamIcon: state => {
      return state.showHamIcon
    },
    getNavBarState: state => {
      return state.navBarState
    }
  },

  mutations: {
    changeHamIconStatus(state, payload) {
      if (payload.isTrusted !== true) {
        state.showHamIcon = payload
      }
      else {
        state.showHamIcon = !state.showHamIcon
      }
    },
    setSideNav(state, payload) {
      state.navBarState = JSON.parse(window.localStorage.getItem('isNavBarOpen'))
    }
  },

  actions: {
    changeHamIconStatus({ commit }, payload) {
      commit('changeHamIconStatus', payload)
    }
  },

  modules: {
    errors: VuexErrors
  }
}
